import 'es6-promise/auto'
import 'whatwg-fetch'
import Uppy from '@uppy/core'
import XHRUpload from '@uppy/xhr-upload'
import Dashboard from '@uppy/dashboard'
import ProgressBar from '@uppy/progress-bar'
import Informer from '@uppy/informer'
import ThumbnailGenerator from '@uppy/thumbnail-generator'
import FileInput from '@uppy/file-input'
import AwsS3 from '@uppy/aws-s3'

export function uppyMultipleFileUpload(fileInput, server) {
  var uppyTarget = fileInput.parentNode
  var formGroup  = fileInput.closest("[data-photo-upload]")

  var fieldNameTemplate = fileInput.name

  var uppy = fileUpload(fileInput, server)

  var openButton = formGroup.querySelector("[data-photo-upload-button]")
  openButton.addEventListener("click", (e) => {
    e.preventDefault()
  })

  uppy
    .use(Dashboard, {
      target: uppyTarget,
      trigger: openButton,
      inline: false,
      height: 300,
      replaceTargetContent: true,
      closeModalOnClickOutside: true,
      closeAfterFinish: true
    })

  var index = new Date().getTime()

  uppy.on('upload-success', function (file, response) {
    var uploadedPhotosLabel = formGroup.querySelector("[data-photo-upload-label]")
    var noPhotoLabel = uploadedPhotosLabel.querySelector('[data-no-photo-label]')

    var hiddenField = document.createElement('input')
    hiddenField.type = 'hidden'
    hiddenField.name = fieldNameTemplate.replace(/\[index\]/, `[${index}]`).replace(/\[\]/, '')
    hiddenField.value = uploadedFileData(file, response, fileInput, server)

    var fileLabel = document.createElement('div')
    fileLabel.classList.add("uploaded-file")
    var domString = `<span>${file.name}</span>&nbsp;<a href="" data-revome-uploaded-file=true class="photo-remove">Poista kuva</a>`;
    fileLabel.innerHTML = domString;
    fileLabel.appendChild(hiddenField)

    index += 1

    fileLabel.addEventListener("click", (e) => {
      e.preventDefault()
      if (!e.target.dataset.revomeUploadedFile) {
        return
      }
      e.currentTarget.remove()
      toggleNoPhotoLable(noPhotoLabel)
      uppy.removeFile(file.id)
    })

    uploadedPhotosLabel.appendChild(fileLabel)
    toggleNoPhotoLable(noPhotoLabel)
  })

  uppy.on('error', error => {
    // Create a new div element
    var errorDiv = document.createElement('div');

    // Set its text content to the error message
    errorDiv.textContent = 'Uppy error: ' + error.message;

    // Append the new div to the parent of the .uppy-Dashboard-files element
    var dashboardFiles = document.getElementsByClassName('uppy-Dashboard-files')[0];
    dashboardFiles.parentNode.appendChild(errorDiv);
  })
}

function toggleNoPhotoLable(label, index) {
  var imageCnt = label.closest('[data-photo-upload]').querySelectorAll('.uploaded-file').length
  if (imageCnt > 0) {
    label.style.display = "none";
    return
  }

  label.style.display = "block";
}

// Keep in sync with content_length_range in config/initializers/shrine.rb.
const MAX_UPLOAD_BYTES = 10 * 1024 * 1024

// Bytes of the file header we read before deciding whether a file is readable.
// No image format begins with thousands of zero bytes, so this is plenty.
const HEADER_BYTES = 4096

// FileReader rather than Blob#arrayBuffer: this file already polyfills for
// older browsers, and readAsArrayBuffer works everywhere Uppy does.
function readHeader(blob) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader()
    reader.onload = () => resolve(new Uint8Array(reader.result))
    reader.onerror = () => reject(reader.error || new Error("read failed"))
    reader.readAsArrayBuffer(blob)
  })
}

// Returns "unreadable" only when the bytes are provably absent -- an empty read,
// or a header of nothing but zeros. Everything else returns "ok".
//
// This fails OPEN by design. We are catching one specific failure: iOS with
// iCloud "Optimize iPhone Storage" hands the browser a file of the right length
// full of zeros. Anything we cannot prove is broken must be allowed through,
// because the browser is not the authority on what libvips can decode -- it
// supports formats no allowlist here would keep up with, and a valid SVG may
// legitimately begin with a BOM, whitespace, a comment or a doctype. The server
// already retries what it can and reports to Honeybadger what it cannot;
// wrongly blocking a real photo has no such recovery.
function inspectHeader(file) {
  try {
    return readHeader(file.data.slice(0, HEADER_BYTES)).then(
      (bytes) => {
        if (bytes.length === 0) return "unreadable"
        if (bytes.every((byte) => byte === 0)) return "unreadable"
        return "ok"
      },
      () => "ok"
    )
  } catch (e) {
    return Promise.resolve("ok")
  }
}

function rejectionMessage(file) {
  // The cause is iOS with iCloud "Optimize iPhone Storage": the photo is not on
  // the device, so the browser hands us a file of the right length full of
  // zeros. Opening the photo once downloads it, so retrying often works.
  return `${file.name}: kuvaa ei voitu lukea. Jos kuva on iCloudissa, avaa se ensin Kuvat-sovelluksessa ja yritä uudelleen.`
}

// Rejects files the browser could not actually read, before they are uploaded.
// Without this a zero-filled read still reaches S3, and the failure only
// surfaces later when server-side processing cannot decode it.
function addImageIntegrityCheck(uppy) {
  uppy.addPreProcessor((fileIDs) =>
    Promise.all(
      fileIDs.map((id) => {
        var file = uppy.getFile(id)
        if (!file) return Promise.resolve()

        return inspectHeader(file).then(
          (verdict) => {
            if (verdict === "ok") return

            uppy.removeFile(id)
            uppy.info(rejectionMessage(file), "error", 10000)
          },
          // Never let this check reject the preprocessor promise: that would
          // fail the whole upload batch rather than a single file.
          () => {}
        )
      })
    )
  )
}

function fileUpload(fileInput, server) {
  var uppy = new Uppy({
      id: fileInput.id,
      autoProceed: false,
      restrictions: {
        allowedFileTypes: fileInput.accept.split(','),
        // Must match the content_length_range on Shrine's presign endpoint.
        // Without it S3 rejects anything larger with an opaque 400 *after* the
        // user has waited through the whole upload.
        maxFileSize: MAX_UPLOAD_BYTES,
      },
      locale: {
        strings: {
          exceedsSize: '%{file} on liian suuri. Suurin sallittu koko on %{size}.',
        }
      }
    })
  if (server == "s3") {
    uppy.use(AwsS3, {
      companionUrl: '/', // will call Shrine's presign endpoint mounted on `/s3/params`
    })
  } else {
    uppy.use(XHRUpload, {
      endpoint: '/upload', // will call Shrine's upload endpoint mounted on `/upload`
    })
  }

  addImageIntegrityCheck(uppy)

  return uppy
}

function uploadedFileData(file, response, fileInput, server) {
  // construct uploaded file data in the format that Shrine expects
  if (server == "s3") {
    return JSON.stringify({
      id: file.meta['key'].match(/^cache\/(.+)/)[1], // object key without prefix
      storage: 'cache',
      metadata: {
        size:      file.size,
        filename:  file.name,
        mime_type: file.type,
      }
    })
  } else {
    return JSON.stringify(response.body)
  }
}



